export default function Autoridade() {
  return (
    <section className="py-12 sm:py-20 bg-gradient-to-b from-white to-teal-50/30 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          {/* Coluna Esquerda - Foto */}
          <div className="relative">
            <div className="relative w-full h-[320px] sm:h-[440px] lg:h-[550px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/4151d53f-b58a-4984-824c-2da718f4fc13.jpg"
                alt="Dr Raphael Teixeira"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-teal-500/20 rounded-full blur-3xl"></div>
          </div>

          {/* Coluna Direita - Texto */}
          <div className="space-y-6">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
              Quem desenvolveu esse método
            </h2>

            <div className="space-y-2">
              <h3 className="text-xl sm:text-2xl font-bold text-teal-600">
                Dr Raphael Teixeira
              </h3>
              <p className="text-base sm:text-lg text-gray-700 font-medium">
                Neurologista especialista em Alzheimer
              </p>
            </div>

            <div className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
              <p>
                Com mais de 15 anos de experiência no tratamento de pacientes com Alzheimer, Dr Raphael desenvolveu um método prático e eficaz para ajudar famílias a lidarem com os desafios diários da doença.
              </p>
              <p>
                Seu protocolo é baseado em evidências científicas e na experiência real de centenas de famílias que conseguiram reduzir significativamente as crises comportamentais.
              </p>
              <p>
                O método combina neurociência, psicologia comportamental e estratégias práticas que podem ser aplicadas imediatamente no dia a dia.
              </p>
            </div>

            <div className="flex flex-wrap gap-3 pt-2">
              <div className="bg-teal-50 border border-teal-200 px-4 py-2 rounded-lg">
                <p className="text-teal-700 text-sm font-medium whitespace-nowrap">Neurologista CRMES 15321</p>
              </div>
              <div className="bg-teal-50 border border-teal-200 px-4 py-2 rounded-lg">
                <p className="text-teal-700 text-sm font-medium whitespace-nowrap">Especialista em Alzheimer</p>
              </div>
              <div className="bg-teal-50 border border-teal-200 px-4 py-2 rounded-lg">
                <p className="text-teal-700 text-sm font-medium whitespace-nowrap">15+ anos de experiência</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
